import { ConfigurationTypes } from "../../../../vendor_core/core/src/const/ConfigurationTypes";
import ConfigManager from "../../../../vendor_core/core/src/managers/ConfigManager";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import * as GameCommands from "../../../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../../../vendor_core/src/commands/VendorCommands";
import { UIButtons } from "../../../../vendor_core/core/src/ui/UIButtons";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import SwitchButton from "../../../../vendor_core/core/src/views/components/SwitchButton";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";
import DoubleChanceConfig from "../../../configs/DoubleChanceConfig";
import DoubleChanceModel from "../../../model/DoubleChanceModel";
import Layout from "../../../../vendor_core/core/src/utils/Layout";
import SoundController from "../../../../vendor_core/core/src/utils/SoundController";
import GameSoundVars from "../../enums/GameSoundVars";
import CurrencyUtils from "../../../../vendor_core/core/src/utils/CurrencyUtils";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import Utils from '../../Utils';
import App from '../../../../vendor_core/core/src/App';
import SoundVars from '../../../../vendor_core/core/src/const/SoundVars';
import { DefaultStates } from '../../../../vendor_core/core/src/states/DefaultStates';
import VendorModel from '../../../../vendor_core/src/model/VendorModel';
import StateMachine from "../../../../vendor_core/core/src/states/StateMachine";
import AutoplayModel from '../../../../vendor_core/core/src/model/AutoplayModel';




export function ShowBuyFeatureOptions() {
    const price = getScatterBoostCost()
    // if (!(BetModel.balance - price >= 0)) {
    //     return;
    // }

    let isActive = !DoubleChanceModel.isActivated;
    // const dcButton = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene()
    //     .buttons.get("buyfeatureSpin") as SwitchButton;
    const dcButton = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene()
        .buttons.get(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt") as SwitchButton;

    // const dcButtonText = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene()
    //     .sceneTextFields.get('BUY_FREESPINS_H2_1')

    dcButton.switch(isActive);

    // dcButtonText.alpha = isActive ? 0.5 : 1;

    if (!DoubleChanceModel.isActivated) {
        // SoundController.playSound(GameSoundVars.SCATTER_BOOST_ON);
    }

    const fbButton = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene().buttons.get("feature");
    fbButton.setEnabled(!isActive);

    const spinBtn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene().buttons.get("spin") as SwitchButton;
    spinBtn.switch(isActive);

    const betBarScene = ViewManager.getLayer("BetBarBottom").getCurrentScene();
    const betField = betBarScene.sceneMoneyFields.get("bet");
    console.log(betField);

    if (isActive) {
        DoubleChanceModel.isActivated = true;
        const scatterBoostScene = ViewManager.getLayer("ScatterBoostCost").setScene("open");
        const cost = getScatterBoostCost();
        scatterBoostScene.sceneMoneyFields.get("total_cost").value = cost;
        betBarScene.sceneMoneyFields.get("bet_amountAlt").alpha = 0.2;

    } else {
        DoubleChanceModel.isActivated = false;
        ViewManager.getLayer("ScatterBoostCost").clear();
        betBarScene.sceneMoneyFields.get("bet_amountAlt").alpha = 1;
    }


}

export function ChangeBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    if (DoubleChanceModel.isActivated) {
        const scatterBoostScene = ViewManager.getLayer("ScatterBoostCost").getCurrentScene();

        let BoostCost = getScatterBoostCost(betData.value, betData.coinIndex)

        scatterBoostScene.sceneMoneyFields.get("total_cost").value = BoostCost

        const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene();
        betBarSceen.sceneMoneyFields.get("dc_bet_amount").value = BoostCost
    }
}

export function ToggleBetPopupCommand(visible) {
    if (visible) {
        ViewManager.resetLayersZOrder();
    } else {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, "BetBarPopups");
    }
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && Configs.game.clientConfig.quickStop;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const betBarSceen = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
    const btnValue = betBarSceen.sceneMoneyFields.get("dc_bet_amount");
    const buttons = betBarSceen.buttons;

    const cost = getScatterBoostCost();

    btnValue.value = cost;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    disabledBtnNames.push("feature");
    // disabledBtnNames.push("buyfeatureSpin");
    disabledBtnNames.push(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt");

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            if (name == "feature") {
                btn.setEnabled(visible != true
                    ? false
                    : DoubleChanceModel.isActivated
                        ? false
                        : true);
            } else {
                btn.setEnabled(visible != true ? false : true);
            }
        }
    });
    GameCommands.ToggleBetPopupCommand();
}

export function getScatterBoostCost(totalBet = BetModel.totalBet, coinIndex = BetModel.coinSizeIndex) {

    const betMultiplier =  BetModel.creditValues[coinIndex] / 100;
    const scatterBoostCreditsPerBet = DoubleChanceConfig.scatterBoostCreditsPerBet;
    const value = betMultiplier * scatterBoostCreditsPerBet + totalBet;

    return value;

}

export function UpdateTotalCost(value) {
    if (DoubleChanceModel.isActivated) {
        const scatterBoostScene = ViewManager.getLayer("ScatterBoostCost").getCurrentScene();
        scatterBoostScene.sceneMoneyFields.get("total_cost").value = value;
    }
}

export function ToggleAutoplayPopupCommand(visible) {
    if (visible) {
        ViewManager.resetLayersZOrder();
    } else {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, "BetBarPopups");
    }
    const isTurboEnable = ConfigManager.hasConfig(ConfigurationTypes.GAME) && Configs.game.clientConfig.quickStop;
    const disabledBtnNames: string[] = [UIButtons.AutoPlay, UIButtons.Spin, UIButtons.Bet, UIButtons.Settings];

    const buttons = ViewManager.getLayer(DefaultLayers.BetBar)
        .setScene().buttons;

    if ( isTurboEnable && buttons.has("turbo")) {
        disabledBtnNames.push(UIButtons.Turbo);
    }

    disabledBtnNames.push("feature");
    // disabledBtnNames.push("buyfeatureSpin");
    disabledBtnNames.push(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt");

    buttons.forEach((btn, name) => {
        if(disabledBtnNames.indexOf(name) != -1) {
            if (name == "feature") {
                btn.setEnabled(visible != true
                    ? false
                    : DoubleChanceModel.isActivated
                        ? false
                        : true);
            } else {
                btn.setEnabled(visible != true ? false : true);
            }
        }
    });
    GameCommands.ToggleAutoplayPopupCommand();
}

export function SpinCommand(playSpinSound: boolean) {
    VendorModel.spinStartTime = Date.now();
    let skippable = new Array<string>(
      DefaultStates.Idle,
      DefaultStates.Finish,
      DefaultStates.ShowWin,
      "coin_collect"
    );

    if (StateMachine.currentState.name == DefaultStates.ShowWin) {
      const elapsedSeconds = (new Date().getTime() - (<any>StateMachine.currentState).timer) / 1000;
      if (elapsedSeconds < (App.config.autoSpinDelay || 0.1)) {
        // Ensure the player will see the win at least for a small amount of time.
        // Without this check if the player holds the spacebar, s/he will miss the winnings.
        return;
      }
    }

    if (!skippable.includes(StateMachine.currentState.name)) {
      // Fixes the nbt game hangs, when clicking fast
      // on the spin button, during big win
      return;
    }

    if (!AutoplayModel.isAutoSpinActive()) {
        SoundController.playSound(SoundVars.BUTTON_SPIN, false);
    }

    StateMachine.skip();
  }

export function ToggleSettingsCommand(visible) {
    VendorCommands.ToggleSettingsCommand();
    if (visible) {
        ViewManager.moveLayerOnTop(DefaultLayers.BetBarBottom, DefaultLayers.MenusBackground);
        Utils.changeBottomBarAlpha();
    } else {
        Utils.changeBottomBarAlpha(0.7);
        ViewManager.resetLayersZOrder();
    }
    VendorCommands.ToggleHomeBtnCommand();
}
